import { useTranslation } from 'react-i18next';
import { Select } from '@cortex/web-design-system/components/ui/Select';
import type { PmoDeliveryQuarterOption } from '../../../types/pmo-delivery.js';

export interface QuarterSelectProps {
  /** 選択できる四半期（進行中が先頭、以降は新しい順） */
  quarters: PmoDeliveryQuarterOption[];
  /** 選択中の四半期キー */
  value: string;
  /** 選択変更コールバック */
  onChange: (quarterKey: string) => void;
}

/**
 * デリバリー view の四半期セレクト。
 *
 * 進行中の四半期には「進行中」を添える。終了した四半期は Q 終了時点で凍結された値で、
 * 見えている数字の意味が違うため、選ぶ前に区別が付くようにしておく。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business PMOデリバリーviewの四半期セレクト。進行中の四半期には注記を添えて、凍結済みの過去Qと区別できるようにする
 * @graph-connects Select [calls] セレクトコンポーネント描画
 */
export function QuarterSelect({ quarters, value, onChange }: QuarterSelectProps) {
  const { t } = useTranslation();

  const options = quarters.map((q) => {
    const label = t('kpi.pmoDelivery.quarterLabel', {
      fiscalYear: q.fiscalYear,
      quarter: q.quarter,
    });
    return {
      value: q.key,
      label: q.isCurrent ? t('kpi.pmoDelivery.quarterSelect.current', { quarter: label }) : label,
    };
  });

  return (
    <Select
      options={options}
      value={value}
      onChange={(e) => {
        onChange(e.target.value);
      }}
      size="sm"
      aria-label={t('kpi.pmoDelivery.quarterSelect.label')}
    />
  );
}
